//MODULO
import {ValueItem} from "@shared/components/bc-select-box/bc-select-box.component";

export const ADMIN_MODULE = 'administrador';
export const VALIDATIONS_PROCESS_MODULE = 'procesos-validaciones';
export const REPORTS_MODULE = 'reportes';

//PANTALLAS Y BOTONES
export const ADMIN_ROL = 'ADMINISTRADOR';

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 5;

export const FIELD_TYPES: ValueItem[] = [
  { label: 'Campo alfanúmerico', value: { codigo: 'TEXTBOX' } },
  { label: 'Campo númerico', value: { codigo: 'NUMBER' } },
  { label: 'Campo de fecha', value: { codigo: 'DATE' } }
];

export const FIELD_TYPE_MAPPING: {[k: string]: string} = {
  'TEXTBOX': 'Alfanumérico',
  'NUMBER': 'Numérico',
  'DATE': 'Fecha',
};

export const USER_REPORT_URLS: Record<string, string> = {
  'PROCESS_EXECUTION_HISTORY': '/app/reportes/reporte-procesos-validaciones'
};

export const CAP_PROCESS_CONDITIONS = 198;
export const ADD_PROCESS_CONDITIONS_ACTION = 1;
export const DELETE_PROCESS_CONDITIONS_ACTION = 2;

export const CAP_VALIDATE_PROCESS = 199;

export const VALIDACION_DATOS_OBLIGATORIOS_PROPIEDADES = [
  "idCliente",
  "sucursal",
  "linea",
  "operacion",
  "codDocumento",
  "idProveedor",
];

export const VALIDACION_FILTRO_PROPIEDADES = [
  "fNitcli",
  "fNoper1",
  "fNoper2",
  "fNoper3",
  "fNoper4",
  "fNoper5",
  "fFecDesde",
  "fFecHasta",
  "fEstAnt",
  "fTippago",
  "fCodplan",
  "fTipact",
  "fOrden",
  "fTipord",
  "fNropag",
  "fRegpag",
  "fCodpro",
  "fEstado",
  "fecvto1",
  "fecvto2",
  "fecvto3",
  "fecvto4",
  "fecvto5",
  "cmpLibre"
];

export const CAMPOS_DINAMICOS_PROPIEDADES: Record<string, string> = {
  cmpDinamico3: 'valorCmpDin3',
  cmpDinamico2: 'valorCmpDin2',
  cmpDinamico1: 'valorCmpDin1',
}

export const CAMPO_DINAMICO_VARCHAR = 'cmpDinamico1';

export const CAMPO_DINAMICO_NUM_EXT = 'cmpDinamico4';
export const VALOR_DINAMICO_NUM_EXT = 'valorCmpDin4';

